<template>
  <v-data-table
    :headers="headers"
    :items="items"
    sort-by="extTraining.dateTimeOfOccurrence"
    :items-per-page="-1"
    fixed-header
    dense
    hide-default-footer
    :no-data-text="$t('profile.history.noData')"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-subheader class="subtitle font-weight-bold text-uppercase">{{
          $t("profile.subheader.extTrainings")
        }}</v-subheader>
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>

    <template v-slot:[`item.groups`]="{ item }">
      <v-chip
        v-for="groupName in groupNamesByCategoryId.get(
          item.extTraining.categoryId
        ) || []"
        :key="groupName"
        small
      >
        {{ groupName }}
      </v-chip>
    </template>

    <template v-slot:[`item.extTraining.dueInMonths`]="{ item }">
      {{
        item.extTraining.dueInMonths === 0 ? "-" : item.extTraining.dueInMonths
      }}
    </template>

    <template v-slot:[`item.extTraining.dateTimeOfOccurrence`]="{ item }">
      {{ item.extTraining.dateTimeOfOccurrence | date }}
    </template>
  </v-data-table>
</template>

<script>
import ExtTrainingGroupsQuery from "@/graphql/queries/ExtTrainingGroups.gql";
export default {
  props: {
    extTrainingEmployee: {
      type: Array,
      required: true,
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "ID",
          value: "extTraining.id",
          class: "text-uppercase subheading text-truncate",
        },
        {
          text: this.$i18n.t("extTrainings.column.category"),
          value: "extTraining.category",
          class: "text-uppercase subheading text-truncate",
        },
        {
          text: this.$i18n.t("extTrainings.column.groups"),
          value: "groups",
          class: "text-uppercase subheading text-truncate",
        },
        {
          text: this.$i18n.t("extTrainings.column.name"),
          value: "extTraining.name",
          class: "text-uppercase subheading text-truncate",
        },
        {
          text: this.$i18n.t("extTrainings.dueInMonths"),
          value: "extTraining.dueInMonths",
          class: "text-uppercase subheading text-truncate",
        },
        {
          text: this.$i18n.t("extTrainings.column.date"),
          value: "extTraining.dateTimeOfOccurrence",
          class: "text-uppercase subheading text-truncate",
        },
        {
          text: this.$i18n.t(`extTrainings.column.educator`),
          value: `extTraining.educator`,
          class: "text-uppercase subheading text-truncate",
        },
        {
          text: this.$i18n.t(`extTrainings.column.location`),
          value: `extTraining.location`,
          class: "text-uppercase subheading text-truncate",
        },
        {
          text: this.$i18n.t(`extTrainings.durationMinutes`),
          value: `extTraining.durationMinutes`,
          class: "text-uppercase subheading text-truncate",
        },
      ];
    },
    items() {
      return this.extTrainingEmployee.filter((t) => t.participated);
    },
    groupNamesByCategoryId() {
      const m = new Map();

      if (!this.extTrainingGroups) {
        return m;
      }

      this.extTrainingGroups.forEach((etg) => {
        etg.extTrainingCategories.forEach((etc) => {
          if (!m.has(etc.id)) {
            m.set(etc.id, []);
          }
          const groupNames = m.get(etc.id);
          if (!groupNames.includes(etg.name)) {
            groupNames.push(etg.name);
          }
        });
      });
      return m;
    },
  },
  apollo: {
    extTrainingGroups: {
      query: ExtTrainingGroupsQuery,
    },
  },
};
</script>
